import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { DOWNLOAD_PATH, REPORT_RECEIVED_PATH } from "lib"
import { ReceivedReportRequest } from "types/request/ReceivedReportRequest"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
)

export const generateReportService = async (request: ReceivedReportRequest) => {
  try {
    const result = await instance.post(
      DOWNLOAD_PATH + REPORT_RECEIVED_PATH,
      request,
    )
    return result
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
